import React from "react";
import { Link } from "react-router-dom";
import { Headline } from "./components/headline/Headline";
import { useState } from "react";

import './sass/_navbar.sass';
import Navcard from "./components/navcards/Navcard";

import WorkImg from './assets/img/img-nav-work.jpg';
import AboutImg from './assets/img/img-nav-about.jpg';
import GalleryImg from './assets/img/img-nav-gallery.jpg';

import svtIcn from './assets/img/icn-work-svt.svg';
import getwetIcn from './assets/img/icn-work-getwet.svg';

function Navbar() {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  return (
    <nav>
      <div>
        <div className="top-nav">
          <Link to="/">
            <Headline level="h1">Marbin Karaus</Headline>
          </Link>
          <div className={isNavExpanded ? "mobile-nav-trigger active" : "mobile-nav-trigger"} onClick={() => { setIsNavExpanded(!isNavExpanded) }}>
            <div className="burger__line"></div>
            <div className="burger__line"></div>
            <div className="burger__line"></div>
          </div>
        </div>
        <div className={isNavExpanded ? "mobile-nav active" : "mobile-nav"}>
          <div>
            <p>Hamburg based Full Stack Developer. Ich liebe Bresso (Frischkäse) und Deko vom Flohmarkt. Ausserdem leben meine Pflanzen bereits seit 7 Jahren.</p>
          </div>
          <div>
            <Navcard image={AboutImg} title="About" text="Lass uns kennenlernen" link="/" onClick={() => setIsNavExpanded(false)} />
            <Navcard image={WorkImg} title="Work" text="Auswahl meiner Jobs" link="/work" onClick={() => setIsNavExpanded(false)} />
            <Navcard image={GalleryImg} title="Gallery" text="Was ich sonst so mache" link="https://gallery.marb.in/" target="external" onClick={() => setIsNavExpanded(false)} />
          </div>
          <div>
            <p className="quick-cases">Quick Cases</p>
            <Navcard image={svtIcn} title="svt" text="Website" link="/work/svt" onClick={() => setIsNavExpanded(false)} />
            <Navcard image={getwetIcn} title="GetWet" text="Desktop App" link="/work/getwet" onClick={() => setIsNavExpanded(false)} />
          </div>
          {isNavExpanded && (
            <Link className="button" to="mailto:hallo@marb.in">Talk to me</Link>
          )}
        </div>
      </div>
      <div className="border-top divider">
        <Link className="button" to="mailto:hallo@marb.in">Talk to me</Link>
      </div>
    </nav>
  );
}

export default Navbar;